<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard addPage">
        <div class="p-grid">
            <div class="p-col-12 mainFormPadding">
                <div class="card ">
                    <p-toast key="toastmsg"></p-toast>
                    <form [formGroup]="rewardForm">
                        <div class="p-fluid p-formgrid p-grid m-0">
                            <div class="p-field p-col-12 div-border p-p-0"> 
                                <h3 class="head-page-title">
                                {{pagetitle}}
                                </h3>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-fluid p-formgrid p-grid baner-image-update">
                                    <div class="p-field p-col-4">
                                        <label>Reward Name<span class="mandatory-feilds">*</span></label>
                                        <input id="reward_name" placeholder="Enter Rewards Name" formControlName="reward_name" type="text"
                                        pInputText [ngClass]="{ 'is-invalid': submitted && f.reward_name.errors }">
                                        <div *ngIf="submitted && f.reward_name.errors" class="invalid-feedback">
                                        <div *ngIf="f.reward_name.errors.required">Reward Name is required</div>
                                        </div>
                                    </div>
                                    <div class="p-field p-col-4">
                                        <label>Coins Required<span class="mandatory-feilds">*</span></label>
                                        <input placeholder="Enter Coins Required" formControlName="coins" type="text" pInputText
                                        [ngClass]="{ 'is-invalid': submitted && f.coins.errors }">
                                        <div *ngIf="submitted && f.coins.errors" class="invalid-feedback">
                                        <div *ngIf="f.coins.errors.required">Coins is required</div>
                                        <div *ngIf="f.coins.errors.pattern">Only Numbers Allowed</div>
                                        </div>
                                    </div>
                                    <div class="p-field p-col-4">
                                        <div class="statusdiv ">
                                            <label>Size Available</label>
                                            <div class="swichTable">
                                            <p-inputSwitch class="checkbox-mt-10" formControlName="size"
                                                [ngClass]="{ 'is-invalid': submitted && f.size.errors }"></p-inputSwitch>
                                            </div>
                                        </div>
                                        <div *ngIf="submitted && f.size.errors" class="invalid-feedback">
                                            <div *ngIf="f.size.errors.required">Please Select Size</div>
                                        </div>
                                    </div>
                                    <div class="p-field p-col-12">
                                        <label>Description<span class="mandatory-feilds">*</span></label>
                                        <textarea inputId="textarea" formControlName="description" rows="5" cols="30" class="form-control"
                                            pInputTextarea [ngClass]="{ 'is-invalid': submitted && f.description.errors }"></textarea>
                                        <div *ngIf="((submitted && f.description.errors) || (f.description.errors && (f.description.dirty || f.description.touched)))"
                                            class="invalid-feedback">
                                            <div *ngIf="f.description.errors.required">Description is required</div>
                                        </div>
                                    </div>
                                    <input formControlName="disable" type="hidden" value="false">
                                    <!-- <div class="p-field p-col-12 uploadBtn">
                                        <div class="subTitleLable">
                                            <h4>Reward Photo <span class="mandatory-feilds">*</span></h4>
                                        </div>
                                        <p-fileUpload name="myfiles[]" multiple="multiple" chooseLabel="Upload" uploadLabel="Show data"
                                        cancelLabel="Cancel" accept="image/*" maxFileSize="10000000" auto="auto" customUpload="true"
                                        (uploadHandler)="uploadRewardImages($event)" (onRemove)="removeRewardImages($event)" 
                                        [ngClass]="{ 'is-invalid': submitted && this.rewardImagesFormArray.length === 0 }">
                                        </p-fileUpload>
                                        <div *ngIf="submitted && this.rewardImagesFormArray.length === 0" class="invalid-feedback">
                                            <div>Reward Photos are required</div>
                                        </div>
                                    </div> -->
                                    <div class="p-field p-col-12 uploadBtn">
                                        <div class="subTitleLable">
                                            <h4>
                                                Reward Photo
                                                <span class="mandatory-feilds">*</span>
                                            </h4>
                                        </div>
                                        <p-fileUpload
                                            #fileUpload
                                            mode="basic"
                                            name="myfiles[]"
                                            [multiple]="true"
                                            chooseLabel="Upload"
                                            accept="image/*"
                                            [maxFileSize]="imageSize"
                                            [auto]="false"
                                            [customUpload]="true"
                                            (onSelect)="onFileSelect($event)"
                                            [ngClass]="{ 'is-invalid': submitted && this.rewardImagesFormArray.length === 0 }">
                                            <ng-template pTemplate="content">
                                            </ng-template>
                                        </p-fileUpload>
                                        <div
                                            *ngIf="submitted && rewardImagesFormArray.length === 0"
                                            class="invalid-feedback">
                                            <div>Reward Photos are required</div>
                                        </div>
                                    </div>
                                    <div class="preview-container">
                                        <div
                                            class="preview-box"
                                            *ngFor="let item of rewardImagesFormArray.controls; let i = index">
                                            <img [src]="item.value.file">
                                            <button
                                                type="button"
                                                class="remove-btn"
                                                (click)="removeRewardImages(i)">
                                                <i class="pi pi-times"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <p-dialog
                                        [(visible)]="cropDialog"
                                        [closable]="true"
                                        (onHide)="onDialogHide()"
                                        [modal]="true"
                                        [appendTo]="'body'"
                                        [style]="{width: '720px'}"
                                        [breakpoints]="{'768px': 'calc(100vw - 24px)'}"
                                        styleClass="custom-crop-dialog">
                                        <ng-template pTemplate="header">
                                            <div class="crop-header-wrapper">
                                                <div class="crop-header-icon-box">
                                                    <i class="pi pi-image header-icon"></i>
                                                </div>
                                                <div class="crop-header-text">
                                                    <h5 class="crop-dialog-title">{{cropDialogTitle}}</h5>
                                                    <p class="crop-dialog-subtitle">{{cropDialogSubtitle}}</p>
                                                </div>
                                            </div>
                                        </ng-template>

                                        <div class="crop-dialog-content-wrapper">
                                            <div class="crop-toolbar-bar mb-3">
                                                <div class="toolbar-hint">
                                                    <i class="pi pi-sliders-h mr-2 hint-icon"></i>
                                                    <span>Zoom & Scale</span>
                                                </div>
                                                <div class="zoom-actions">
                                                    <button type="button" pButton icon="pi pi-search-plus" label="Zoom In"
                                                        class="crop-btn zoom-btn" (click)="zoomIn()" [disabled]="scale >= 3"></button>
                                                    <button type="button" pButton icon="pi pi-search-minus" label="Zoom Out"
                                                        class="crop-btn zoom-btn" (click)="zoomOut()" [disabled]="scale <= 1"></button>
                                                    <button type="button" pButton icon="pi pi-refresh" label="Reset"
                                                        class="crop-btn reset-btn" (click)="resetZoom()"></button>
                                                </div>
                                            </div>

                                            <div class="cropper-frame mb-3">
                                                <image-cropper
                                                    [imageChangedEvent]="imageChangedEvent"
                                                    [maintainAspectRatio]="true"
                                                    [aspectRatio]="1"
                                                    [resizeToWidth]="1000"
                                                    [resizeToHeight]="1000"
                                                    [onlyScaleDown]="false"
                                                    [imageQuality]="92"
                                                    [backgroundColor]="'#ffffff'"
                                                    [transform]="transform"
                                                    format="jpeg"
                                                    (imageCropped)="imageCropped($event)"
                                                    (loadImageFailed)="onCropImageLoadFailed()">
                                                </image-cropper>
                                            </div>

                                            <div class="crop-error-msg mb-3" *ngIf="croppedImageError">
                                                <i class="pi pi-exclamation-triangle mr-2"></i>
                                                <span>{{croppedImageError}}</span>
                                            </div>

                                            <div class="cropped-preview-box" *ngIf="croppedImage">
                                                <div class="preview-header">
                                                    <div class="preview-title">
                                                        <i class="pi pi-eye mr-2 text-primary"></i>
                                                        <span>Live Cropped Preview</span>
                                                    </div>
                                                    <span class="preview-ratio-badge">{{cropPreviewLabel}}</span>
                                                </div>
                                                <div class="preview-img-container">
                                                    <img [src]="croppedImage" alt="Cropped Reward Photo Preview" class="preview-img" />
                                                </div>
                                            </div>
                                        </div>

                                        <ng-template pTemplate="footer">
                                            <div class="dialog-footer-actions">
                                                <button type="button" pButton label="Cancel" icon="pi pi-times"
                                                    class="cancel-action-btn" (click)="onCropCancel()"></button>
                                                <button type="button" pButton label="Use Image" icon="pi pi-check"
                                                    class="use-image-btn" (click)="applyCrop()"
                                                    [disabled]="isApplyingCrop || !!croppedImageError || !croppedImage"></button>
                                            </div>
                                        </ng-template>
                                    </p-dialog>
                                    <div class="p-field p-col-12">
                                        <div class="instruction">
                                            <p>Instructions:</p>
                                            <ul>
                                            <li>
                                                1) Each cropped Reward Photo will be 1000 x 1000 px with a maximum size of 1 MB.
                                            </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="p-field p-col-1 ">
                                        <div class="statusdiv ">
                                            <label for="status">Status</label>
                                            <div class="swichTable">
                                                <p-inputSwitch class="checkbox-mt-10" formControlName="status"
                                                [ngClass]="{ 'is-invalid': submitted && f.status.errors }"></p-inputSwitch>
                                            </div>
                                        </div>
                                        <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                            <div *ngIf="f.status.errors.required">Please Select Status</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="lineborderHR">
                                            <hr>
                                        </div>
                                <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer">
                                    <div class="p-formgrid p-grid">
                                        <p-toast></p-toast>
                                        <button type="button" (click)="onSubmit()" pButton icon="pi pi-check" label="Save"
                                            class="p-button-success save-btn p-mr-3" style="width: auto"
                                            [disabled]="isSubmitting"></button>
                                        <p-confirmDialog header="Confirmation" key="confirm1" icon="pi pi-exclamation-triangle"
                                        message="Are you sure you want to proceed?" [style]="{width: '425px'}"
                                        acceptButtonStyleClass="p-button-text" rejectButtonStyleClass="p-button-text"></p-confirmDialog>
                                        <button pButton pRipple type="button" icon="pi pi-times" label="Cancel" class="cancel-btn" (click)="backLink()" style="width: auto"></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
